var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00021C0 4.72421 0.224 4.50021 0.5 4.50021L10.4747 4.50021L6.65525 0.862213C6.4555 0.671963 6.44725 0.355713 6.638 0.155213C6.8285 -0.0447874 7.14475 -0.0525375 7.34475 0.137963L11.707 4.29296C11.896 4.48196 12 4.73296 12 5.00021C12 5.26721 11.896 5.51846 11.6982 5.71571L7.34475 9.86221C7.14475 10.0527 6.8285 10.0447 6.638 9.84496C6.44725 9.64521 6.45525 9.32871 6.65525 9.13821L10.4908 5.50021L0.5 5.50021C0.224 5.50021 0 5.27621 0 5.00021Z",
    fill: "#07969E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8549f784d98a6313013b14261daf3637.svg";
export { ForwardRef as ReactComponent };